// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__lWDcc","logo":"default_logo__tofaI","icon":"default_icon__Zd8Ta","label":"default_label__UmafF"};